export default __webpack_public_path__ + "static/3-253d50cdba24d66df828c931ce035d86.png";